<ui-data-table
    variant="detail"
    [tableId]="config.testId || 'detail-table'"
    [caption]="config.caption"
    [columns]="uiColumns"
    [data]="rows"
    [showToolbar]="false"
    [pagination]="false"
    [rowKey]="uiRowKey"
    [expandedRowKeys]="expandedKeys"
    [canExpandRow]="uiCanExpandRow"
    [expanderTestId]="expanderTestId"
    [rowClass]="uiRowClass"
    [rowAttrs]="uiRowAttrs"
    (rowToggle)="onToggle($event)">

    <ng-container *ngFor="let col of config.columns">
        <ng-template [uiTableCell]="col.id" let-row>
            <ng-container *ngIf="customCellTemplate(col.id) as slot; else builtin">
                <ng-container *ngTemplateOutlet="slot.template; context: { $implicit: row, column: col }"></ng-container>
            </ng-container>
            <ng-template #builtin>{{ formattedValue(row, col) }}</ng-template>
        </ng-template>
    </ng-container>

    <ng-template uiTableExpanded let-row>
        <ng-container *ngIf="expandedSlot">
            <ng-container *ngTemplateOutlet="expandedSlot.template; context: { $implicit: row }"></ng-container>
        </ng-container>
    </ng-template>
</ui-data-table>
